import { useScrollReveal } from "@/hooks/useScrollReveal";
import { lean } from "@/content";
import { Rich } from "@/lib/rich";

export default function LeanPhilosophy() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section id="philosophy" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#FAFAF8] via-stone-50 to-[#FAFAF8] dark:from-[#0A0A0A] dark:via-[#0C0C0E] dark:to-[#0A0A0A]" />
      <div className="absolute top-[10%] left-[-5%] w-[400px] h-[400px] rounded-full bg-orange-100/20 blur-[150px] dark:bg-orange-500/[0.08] pointer-events-none" />
      <div className="absolute bottom-[5%] right-[-5%] w-[350px] h-[350px] rounded-full bg-amber-100/20 blur-[130px] dark:bg-amber-500/[0.08] pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
        <div
          ref={ref}
          className={`transition-all duration-700 ${
            revealed ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-stone-100 border border-stone-200 text-stone-600 dark:bg-white/[0.06] dark:border-white/[0.10] dark:text-white/60 text-xs font-semibold tracking-widest uppercase mb-6">
            {lean.philosophy.badge}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-stone-900 leading-tight mb-8 dark:text-white">
            <Rich text={lean.philosophy.title} accentClassName="text-orange-600 dark:text-orange-500" />
          </h2>

          <div className="bg-white border border-stone-200 rounded-3xl p-8 md:p-12 text-left shadow-[0_4px_24px_rgba(0,0,0,0.03)] dark:bg-white/[0.04] dark:border-white/[0.08] dark:shadow-[0_4px_24px_rgba(0,0,0,0.2)]">
            <p className="text-stone-700 text-lg leading-relaxed mb-6 dark:text-white/70">
              {lean.philosophy.paragraphs[0]}
            </p>
            <p className="text-stone-700 text-lg leading-relaxed mb-8 dark:text-white/70">
              {lean.philosophy.paragraphs[1]}
            </p>

            <div className="flex flex-wrap gap-3">
              {lean.philosophy.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-2 rounded-full bg-orange-50 border border-orange-200 text-orange-700 text-xs font-bold dark:bg-orange-500/[0.12] dark:border-orange-400/25 dark:text-orange-300"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}